var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
export default React.memo(function (props) {
    return (React.createElement("svg", __assign({ width: 48, height: 48, viewBox: "0 0 48 48", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { d: "M20.507 18.463L25.978 24l-5.471 5.537a1.748 1.748 0 00-.112 2.334l.112.124a1.706 1.706 0 002.429 0l6.557-6.636c.37-.374.536-.872.5-1.358a1.745 1.745 0 00-.5-1.36l-6.557-6.636a1.707 1.707 0 00-2.43 0 1.748 1.748 0 000 2.458z", fill: "currentColor", stroke: "none", strokeWidth: 1, fillRule: "evenodd" })));
});
